import React, { FC } from "react";
import Checkbox from "../../core/checkbox/Checkbox";
import { bodySm } from "../../core/typography/Typography";

const ToggleInputGroup: FC<{
  items: any[];
  type?: "checkbox" | "radio";
}> = ({ items, type = "checkbox" }) => {
  return (
    <div className="flex flex-wrap gap-x-4">
      {items.map(({ name, receiveValue, color, value, ...item }, i) => (
        <div
          className="flex items-center gap-2"
          key={name || i}
        >
          <Checkbox
            type={type}
            onCheckedChange={receiveValue}
            {...item}
            style={{
              "--border-highlight-default": color,
              "--focused-default": color,
            }}
          />
          {value && <span className={bodySm}>{value}</span>}
        </div>
      ))}
    </div>
  );
};

export default ToggleInputGroup;
